import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { DeepDiveData } from "src/pages/Studies/models/interfaces";

const initialState: DeepDiveData = {
	collaborators: [],
	insight_details: { study_id: "" }, // Initially only contains study_id
	study_name: "",
	study_tags: [],
	user_access_type: "",
	selectedQuesId: null,
	blurOnOpen: false,
};

const deepDiveInsightSlice = createSlice({
	name: "deepdiveData",
	initialState: {
		deepDiveData: initialState,
		// Preview-only: when set (branding live-preview), DeepDive auto-selects this
		// question on load so the answers render without a click (the preview swallows
		// clicks). null in the real app → no behaviour change.
		previewAutoSelectQuesId: null as number | null,
	},
	reducers: {
		setDeepDiveData: (state, action: PayloadAction<any>) => {
			state.deepDiveData = action.payload;
		},
		setPreviewAutoSelectQuesId: (state, action: PayloadAction<number | null>) => {
			state.previewAutoSelectQuesId = action.payload;
		},
		setDeepDiveAccessType: (state, action: PayloadAction<string>) => {
			state.deepDiveData.user_access_type = action.payload;
		},
		setSelectedQuesId: (state, action: PayloadAction<number | null>) => {
			state.deepDiveData.selectedQuesId = action.payload;
		},
		setBlurOnOpen: (state, action: PayloadAction<boolean>) => {
			state.deepDiveData.blurOnOpen = action.payload;
		},
		resetDeepDiveData: (state) => {
			state.deepDiveData = initialState;
		},
	},
});

export const { setDeepDiveData, setDeepDiveAccessType, setSelectedQuesId, setBlurOnOpen, resetDeepDiveData, setPreviewAutoSelectQuesId } = deepDiveInsightSlice.actions;

export default deepDiveInsightSlice.reducer;
